import React from "react";
import AIheader from "../RentAI/AIheader";
import Footer from "../../Component/Footer/Footer";
import { Link } from "react-router-dom";


 

const Index = ()=> {

    return (
        <>
<AIheader />
<main className="mainNew">

<section className='termsBanner'>
    <h1>Accessibility Statement</h1>
</section>


<section className="termsMain">
  <div className="container">
    <div className="row justify-content-center align-items-center">
    <div className="col-lg-12 col-md-12 col-sm-12"> 
            <div className="accessTop"> 
              <p>Rentid Inc is committed to ensuring digital accessibility for people with disabilities. We are continually improving the user experience for everyone and applying the relevant accessibility standards.</p>
            </div>
            <div className="accessInner">
              <h3>Measures to support accessibility</h3>
              <p>Rentid Inc takes the following measures to ensure accessibility of Rentid.io:</p>
              <ul>
                <li>Include accessibility as part of our mission statement.</li>
                <li>Integrate accessibility into our procurement practices.</li>
                <li>Provide continual accessibility training for our staff.</li>
                <li>Assign clear accessibility targets and responsibilities.</li>
              </ul>
            </div>

            <div className="accessInner">
              <h3>Conformance status</h3>
              <p>The Web Content Accessibility Guidelines (WCAG) defines requirements for designers and developers to 
                improve accessibility for people with disabilities. It defines three levels of conformance: Level A, 
                Level AA, and Level AAA.</p>
              <p>Rentid.io is partially conformant with WCAG 2.1 level AA. Partially conformant means that some parts 
                of the content do not fully conform to the accessibility standard.</p>
            </div>

            <div className="accessInner">
              <h3>Feedback</h3>
              <p>We welcome your feedback on the accessibility of Rentid.io. Please let us know if you encounter 
                accessibility barriers on Rentid.io:</p>
              <ul>
                <li>Email: <a href="mailto:accessibility@rentid.io">accessibility@rentid.io</a></li>
                {/* <li>Phone: +1-800-123-4567</li> */}
                <li>Contact Us: <Link to="/general-question">General Questions</Link></li>
                <li>Postal address: 8 The Green Suite 10988, Dover, DE 19901</li>
              </ul>
              <p>We try to respond to feedback within 2 business days.</p>
            </div>

            <div className="accessInner">
                <h3>Compatibility with browsers and assistive technology</h3>
                <p>Rentid.io is designed to be compatible with the following assistive technologies:</p>
                <ul>
                  <li>Modern web browsers (e.g., Chrome, Firefox, Safari, Edge)</li>
                  <li>Screen readers (e.g., JAWS, NVDA)</li>
                </ul>
            </div>
            <div className="accessInner">
                <h3>Technical specifications</h3>
                <p>Accessibility of Rentid.io relies on the following technologies to work with the particular combination 
                    of web browser and any assistive technologies or plugins installed on your computer:</p>
                <ul>
                  <li>HTML</li>
                  <li>WAI-ARIA</li>
                  <li>CSS</li>
                  <li>JavaScript</li>
                </ul>
            </div>
            <div className="accessInner">
              <h3>Limitations and alternatives</h3>
              <p>
                Despite our best efforts to ensure accessibility of Rentid.io, there may be some limitations. Below is a description of known limitations and potential solutions:
              </p>
              <ul>
                <li>
                  <strong>Comments from users:</strong> Uploaded user review images may not have text alternatives. We monitor user reviews & comments and typically repair issues within 2 business days. Please use the 'report issue' button if you encounter an issue.
                </li>
              </ul>
            </div>
            <div className="accessInner">
              <h3>Assessment approach</h3>
              <p>Rentid Inc assessed the accessibility of Rentid.io by the following approaches:</p>
              <ul>
                <li>Self-evaluation</li>
                <li>External evaluation</li>
              </ul>
            </div>

            <div className="accessInner">
              <h3>Formal complaints</h3>
              <p>We aim to respond to accessibility feedback within 2 business days and to propose a solution within 10 business days. You are entitled to escalate a complaint to the management team at Rentid Inc, should you be dissatisfied with our response to you.</p>
            </div>
  
          </div>
    </div>
  </div>
</section>


</main>
<Footer />
        </>
    )
}
export default Index;